<template>
    <v-dialog v-model="dialog" :scrim="false" width="600">
        <v-card>
            <v-card-title class="text-white bg-primary mb-5">
                {{ $t('admin.new_template') }}
            </v-card-title>
            <v-card-text>
                <v-form v-model="valid">
                    <slot>
                        <v-text-field
                            v-model="template.info"
                            :label="$t('admin.templateInfo')"
                            :rules="[requiredRule('admin.templateInfo')]"
                            variant="outlined"
                        />
                        <v-text-field
                            v-model="template.notificationType"
                            :label="$t('admin.templateType')"
                            :rules="[requiredRule('admin.templateType')]"
                            variant="outlined"
                        />
                    </slot>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    :disabled="!valid || isLoading"
                    :loading="isLoading"
                    color="primary"
                    variant="flat"
                    @click="save"
                >
                    {{ $t('save') }}
                </v-btn>
                <v-btn variant="text" @click="dialog = false">{{ $t('cancel') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Emit, mixins, Prop, VModel} from 'vue-facing-decorator'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'

    @Component
    export class NewTemplateDialog extends mixins(FormValidationRulesMixin) {
        @VModel() dialog
        @Prop() template
        @Prop({default: false, type: Boolean}) isLoading

        valid = false

        @Emit()
        save() {
            return this.template
        }
    }

    export default NewTemplateDialog
</script>
